import { Route, lazyRouteComponent } from "@tanstack/react-router";
import {
  searchParamsSchema,
  searchResultQueryOptions,
} from "../containers/booking";
import { rootRoute } from "./root";

export const bookingRoute = new Route({
  validateSearch: (search) => searchParamsSchema.parse(search),
  loaderDeps: ({ search: { providerId, resultId, searchId } }) => ({
    providerId,
    resultId,
    searchId,
  }),
  loader: (options) =>
    options.context.queryClient.ensureQueryData(
      searchResultQueryOptions(options.deps),
    ),
  getParentRoute: () => rootRoute,
  path: "/booking",
  component: lazyRouteComponent(() => import("../pages/booking")),
});
